import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from "@angular/core";
import { MatFormFieldControl } from "@angular/material/form-field";
import { distinctUntilChanged, fromEvent, map, merge, take, takeUntil } from "rxjs";
import { MatFormFieldControlImpl } from "../../ng-material-impl/mat-form-field-control.impl";


@Component({
  selector: 'ss-email-control',
  templateUrl: './email-control.component.html',
  styleUrls: ['./email-control.component.css'],
  providers: [
    { provide: MatFormFieldControl, useExisting: EmailControlComponent }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailControlComponent extends MatFormFieldControlImpl<string> {

  @ViewChild('inputRef')
  private _inputRef: ElementRef<HTMLInputElement>

  readonly valueSubject = this._formControlService.valueSubject;
  readonly touchedSubject = this._formControlService.touchedSubject;
  constructor() {
    super('email')
  }

  ngAfterViewInit() {

    const inputKeyObs = fromEvent<KeyboardEvent>(this._inputRef.nativeElement, 'keyup')
    const changeObs = fromEvent(this._inputRef.nativeElement, 'change')


    merge(inputKeyObs, changeObs)
      .pipe(
        map((evParams) => {
          const htmlInputElement = evParams.target as HTMLInputElement;
          const value = htmlInputElement.value;
          return value;
        }),
        distinctUntilChanged(),
        takeUntil(this._destroy)
      )
      .subscribe((value) => {


        this.valueSubject.next(value)
      })

    const focusOutObs = fromEvent<KeyboardEvent>(this._inputRef.nativeElement, 'focusout')

    focusOutObs
      .pipe(
        take(1),
        takeUntil(this._destroy)
      )
      .subscribe(() => {
        this.touchedSubject.next(true)
      });

  }

  override onContainerClick(event: MouseEvent): void {

    this._inputRef.nativeElement.focus();
  }

}


